import React, { ReactNode, useMemo } from 'react';
import CurrentOrderMutationContext from '../contexts/CurrentOrderMutationContext';
import { useCurrentOrderAddItemsMutation } from '../api';

interface Props {
  children: ReactNode;
}

const CurrentOrderMutationContextProvider = (props: Props) => {
  const [trigger, result] = useCurrentOrderAddItemsMutation();

  const value = useMemo(
    () => ({
      currentOrderAddItems: [trigger, result] as ReturnType<
        typeof useCurrentOrderAddItemsMutation
      >,
    }),
    [trigger, result]
  );

  return (
    <CurrentOrderMutationContext.Provider value={value}>
      {props.children}
    </CurrentOrderMutationContext.Provider>
  );
};

export default CurrentOrderMutationContextProvider;
